module.exports = __webpack_public_path__ + "static/fonts/MyriadPro-BoldSemiCnIt.64921c6.ttf";